var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgDeleteFilled = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5556 10.5511L10.5512 11.5556L8.00009 9.00447L5.44898 11.5556L4.44454 10.5511L6.99565 8.00003L4.44454 5.44892L5.44898 4.44448L8.00009 6.99559L10.5512 4.44448L11.5556 5.44892L9.00454 8.00003L11.5556 10.5511ZM8.00003 0.888916C4.07114 0.888916 0.888916 4.07114 0.888916 8.00003C0.888916 11.9289 4.07114 15.1111 8.00003 15.1111C11.9289 15.1111 15.1111 11.9289 15.1111 8.00003C15.1111 4.07114 11.9289 0.888916 8.00003 0.888916Z",
    fill: "black",
    fillOpacity: 0.54
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDeleteFilled, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/delete-filled.61fe41e4.svg";
export { ForwardRef as ReactComponent };